import styled from '@emotion/styled'
import React from 'react'
import CustomCard from './card'

const getGridContents = (entries = [], useEditorialFields) => {
    return entries.map((entry, i) => (
        <CustomCard
            {...entry}
            key={`${entry.id}--${i}`}
            useGridStyling
            useEditorialFields={useEditorialFields}
        ></CustomCard>
    ))
}

const Grid = ({ data, gridFix, useEditorialFields = false }) => {
    return <GridEl className={`grid ${gridFix}`}>{getGridContents(data, useEditorialFields)}</GridEl>
}

const GridEl = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
    justify-content: flex-start;

    @media screen and (min-width: 672px) {
        &.grid-adjust {
            grid-template-columns: repeat(auto-fit, minmax(270px, 300px));
        }
    }
`

export default Grid
